<template>
    <div>
        <div class="alert alert-warning">
            Enable and setup up services integrations.
        </div>

        <div class="mb-2">
            <facebook-integration
                :integration="location"
                @show="hideLocationFormModal"
                @hide="open"
                @save-integration="saveIntegration"
            />
        </div>

        <div class="row">
            <div class="col-4">
                <google-my-business-integration
                    :integration="location"
                    @show="hideLocationFormModal"
                    @hide="open"
                    @save-integration="saveIntegration"
                />
            </div>

            <div class="col-4">
                <zillow-integration
                    :integration="location"
                    @show="hideLocationFormModal"
                    @hide="open"
                    @save-integration="saveIntegration"
                />
            </div>

            <div class="col-4" v-if="location && location.foreup_credential">
                <foreup-integration
                    :integration="location"
                    @show="hideLocationFormModal"
                    @hide="open"
                    @save-integration="saveIntegration"
                />
            </div>
            <div class="col-4">
                <flare-integration
                    :location="location"
                    @show="hideLocationFormModal"
                    @hide="open"
                />
            </div>

            <div class="col-4" v-if="location && location.has_healthjump_integration">
                <healthjump-integration
                    :location="location"
                    @show="hideLocationFormModal"
                    @hide="open"
                />
            </div>

            <div class="col-4" v-if="location">
                <carestack-integration
                    :location="location"
                    @show="hideLocationFormModal"
                    @hide="open"
                    @save-integration="saveIntegration"
                    />
            </div>

            <div class="col-4" v-if="location">
                <ccc-integration
                    :location="location"
                    @show="hideLocationFormModal"
                    @hide="open"
                    @save-integration="saveIntegration"
                />
            </div>

            <div class="col-4" v-if="location">
                <fareharbor-integration
                    :location="location"
                    @show="hideLocationFormModal"
                    @hide="open"
                    @save-integration="saveIntegration"
                />
            </div>

            <div class="col-4" v-if="location">
                <pestroutes-integration
                    :location="location"
                    @show="hideLocationFormModal"
                    @hide="open"
                    @save-integration="saveIntegration"
                />
            </div>

            <div class="col-4" v-if="location">
                <servicepro-integration
                    :location="location"
                    @show="hideLocationFormModal"
                    @hide="open"
                    @save-integration="saveIntegration"
                />
            </div>

            <div class="col-4" v-if="location">
                <cloudnine-integration
                    :location="location"
                    @show="hideLocationFormModal"
                    @hide="open"
                    @save-integration="saveIntegration"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import FacebookIntegration         from './../integrations/FacebookIntegration';
    import GoogleMyBusinessIntegration from './../integrations/GoogleMyBusinessIntegration'
    import HealthjumpIntegration       from "./../integrations/HealthjumpIntegration";
    import ZillowIntegration           from './../integrations/ZillowIntegration';
    import CarestackIntegration        from './../integrations/CarestackIntegration';
    import cccIntegration              from './../integrations/cccIntegration';
    import FareharborIntegration        from './../integrations/FareharborIntegration';
    import PestroutesIntegration        from './../integrations/PestroutesIntegration';
    import ServiceproIntegration        from "../integrations/ServiceproIntegration";
    import CloudnineIntegration        from './../integrations/CloudnineIntegration';

    export default {
        props: ['location'],

        components: {
            FacebookIntegration,
            GoogleMyBusinessIntegration,
            HealthjumpIntegration,
            ZillowIntegration,
            CarestackIntegration,
            cccIntegration,
            FareharborIntegration,
            PestroutesIntegration,
            ServiceproIntegration,
            CloudnineIntegration,
        },

        data() {
            return {}
        },

        methods: {
            open() {
                this.$emit('show');
            },

            hideLocationFormModal(value) {
                this.$emit('hide', value);
            },

            saveIntegration(locationId) {
                this.$emit('save-location', locationId);
            }
        }
    }
</script>
